import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiTableHead-root': {
			backgroundColor: '#fff',
		},
	},
	cell: {
		display: 'flex',
		alignItems: 'center',
		width: '16.149674620390456vw',
		height: '19px',
	},
	cellStyle: {
		width: '9.25rem',
	},
}));
